<template>
    <div class="my-6 px-4 flex flex-wrap gap-1">
        <DButton
            v-for="(button, index) in buttons"
            :key="`button-${index}`"
            :theme="button.type"
            :wide="button.flex"
            :loading="submitting"
            :right-icon="button.icon ? `ph:${button.icon}` : null"
            @click="handleButton(button)"
        >
            {{ button.title }}
        </DButton>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import { DButton } from '@digistorm/spark'

    const moduleHelpers = useModuleHelpers()
    const { snackbar } = useSnackbars()
    const router = useRouter()

    const props = defineProps({
        config: Object,
    })

    const submitting = ref(false)
    const buttons = ref(props.config.data.buttons)

    const handleButton = (button) => {
        submitting.value = true

        return moduleHelpers.handleClick(router, button, null, false)
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                submitting.value = false
            })
    }

    onMounted(() => {
        moduleHelpers.setAnalyticsScreenFromConfig(props.config)
    })
</script>
